import { HELP_ROUTE_MATRIX } from "./helpRouteMatrix.js";

export function resolveHelpScreenId(pathname = "/") {
  const exact = HELP_ROUTE_MATRIX.find((row) => row.route === pathname);
  if (exact) return exact.screenId;
  const prefix = HELP_ROUTE_MATRIX.filter((row) => row.route !== "/" && pathname.startsWith(row.route)).sort(
    (a, b) => b.route.length - a.route.length,
  )[0];
  return prefix?.screenId || "__fallback__";
}

export function isHelpFallbackScreenId(screenId) {
  return !screenId || screenId === "__fallback__";
}
